// extracted by mini-css-extract-plugin
module.exports = {"timeline":"Timeline_timeline__vb3AH","slider":"Timeline_slider__a9nWY","title":"Timeline_title__GVl0l","nav":"Timeline_nav__j37xK","rotation":"Timeline_rotation__CrYN0"};